

export default function Navbar(props) {
  
  return (
    <div>
        <nav className="navbar">
  <ul className="navbar-list">
    <li className="navbar-item ">
      {props.link === "home" ? <a href="/" className="navbar-link active font-bold hover:bg-transparent">
        About
        </a>: <a href="/" className="navbar-link text-white font-bold hover:bg-transparent">
        About
        </a>}
     
      
    </li>
    <li className="navbar-item">
      {props.link === "resume" ? <a href="/resume" className="navbar-link font-bold active hover:bg-transparent">
        Resume
        </a>: <a href="/resume" className="navbar-link font-bold hover:bg-transparent">
        Resume
        </a>}
    
    </li>
    <li className="navbar-item">
      {props.link === "projects" ? <a href="/projects" className="navbar-link font-bold active hover:bg-transparent">
        Projects
        </a>: <a href="/projects" className="navbar-link font-bold hover:bg-transparent">
        Projects
        </a>}
    
    </li>
    <li className="navbar-item">
      {props.link === "contact" ? <a href="/contact" className="navbar-link font-bold active hover:bg-transparent">
        Contact
        </a>:<a href="/contact" className="navbar-link font-bold hover:bg-transparent">
        Contact
        </a>}
    
    </li>
  </ul>
</nav>

    </div>
  )
}
